import Contact from "./components";
export default Contact;